import React, { useState } from 'react';
import FilterBox, { FilterBoxData } from '../../../my/FilterBox';
import css from './search-bar.module.scss';
import { CreateButton } from '../../../../../../../../shared/ui';
import { AdvancedTemplateSearch } from '../../../../../../../../widgets/templates/advanced-template-search';
import {
	AdvancedSearchTagDropdown,
} from '../../../../../../../../widgets/templates/advanced-search-tag-dropdown/ui/advanced-search-tag-dropdown';
import { useAppDispatch, useAppSelector } from '../../../../../../../../shared/libs/redux';
import {
	useAdvancedSearchSelectedTags,
} from '../../../../../../../../shared/libs/templates/useAdvancedSearchSelectedTags';
import { ITag } from '../../../../../../../../entities/module/private-template-module-tag/api/types';
import { privateTemplateTagAPI } from '../../../../../../../../entities/template/private-template-tag';
import { useDebounce } from '../../../../../../../../shared/libs/useDebounce';
import { useCreatePrivateTemplateTag } from '../../../../../../../../features/template/tag/create-private-template-tag/useCreatePrivateTemplateTag';
import { TypeOfTags } from '../../../../../../../../widgets/modules-modal/private-template-modules-modal/model/types';
import {
	useSelectedGroupTags,
} from '../../../../../../../../widgets/templates/private-template-tag-group-panel/libs/useSelectedGroupTags';
import {
	setPrivateSelectedTags,
	setPrivateTemplateSearch,
} from '../../../../../../../../entities/template/private-template/model/privateTemplateSlice';
import {
	GroupTagList,
// eslint-disable-next-line max-len
} from '../../../../../../../../features/template/tag-group/private-template-tag-group-settings/ui/group-tag-list/GroupTagList';
import {
	PrivateTemplateTagGroupScrollBar,
} from '../../../../../../../../widgets/templates/private-template-tag-group-panel/PrivateTemplateTagGroupScrollBar';

interface PrivateTemplateSearchBarProps {
	isLoading: boolean,
	sortingData: FilterBoxData,
	onTemplateCreate: () => void,
}

/* Кнопка "создать шаблон", поиск и сортировка */
export const PrivateTemplateSearchBar = ({
	isLoading,
	sortingData,
	onTemplateCreate,
}: PrivateTemplateSearchBarProps) => {
	const dispatch = useAppDispatch();

	const [tagSearch, setTagSearch] = useState('');
	const [isDropdownVisible, setIsDropdownVisible] = useState(false);

	const search = useAppSelector(state => state.privateTemplate.search);
	const selectedFilteredTags = useAppSelector(state => state.privateTemplate.selectedTags);

	const setSelectedTags = (tags: ITag[]) => dispatch(setPrivateSelectedTags(tags));
	const setSearch = (value: string) => dispatch(setPrivateTemplateSearch(value));

	const { handleTag } = useAdvancedSearchSelectedTags(selectedFilteredTags, setSelectedTags);
	const { onCreateTag } = useCreatePrivateTemplateTag();

	const debounceSearch = useDebounce(tagSearch.trim(), 200);

	const {
		selectedTags,
		onRemoveTag,
	} = useSelectedGroupTags();

	const { data } = privateTemplateTagAPI.useGetAllQuery({
		limit: 127,
		page: 1,
		search: debounceSearch,
	});

	const removeCreatedGroupTags = (tag: string) => {
		onRemoveTag(Number(tag));
	};

	return (
		<>
			<div className={css.add_block}>
				<CreateButton disabled={isLoading} onClick={onTemplateCreate}>
					Создать шаблон
				</CreateButton>

				<AdvancedTemplateSearch
					search={search}
					selectedTags={selectedFilteredTags}
					isDropdownVisible={isDropdownVisible}
					setSearch={setSearch}
					setIsDropdownVisible={setIsDropdownVisible}
					handleTag={handleTag}
				>
					<AdvancedSearchTagDropdown
						isDropdownVisible={isDropdownVisible}
						tags={data?.templateTags || []}
						setSearch={setTagSearch}
						search={tagSearch}
						selectedTags={selectedFilteredTags}
						createTag={onCreateTag}
						setSelectedTags={setSelectedTags}
					/>
				</AdvancedTemplateSearch>
			</div>

			{/* Виджет - настройка и фильтрация по группам тегов */}
			<PrivateTemplateTagGroupScrollBar
				scrollDistance={200}
				typeOfTags={TypeOfTags.PRIVATE_TAGS}
			/>

			{/* Блок с выбранными тегами (из групп тегов) */}
			{selectedTags.length > 0 && (
				<GroupTagList
					selectedTags={selectedTags}
					onRemoveChoicedItem={removeCreatedGroupTags}
				/>
			)}

			{/* Сортировка */}
			<div className={css.filter}>
				<FilterBox sortingData={sortingData} />
			</div>
		</>
	);
};
